import { render, staticRenderFns } from "./addFloorShare.vue?vue&type=template&id=6aa63873&scoped=true"
import script from "./addFloorShare.vue?vue&type=script&lang=js"
export * from "./addFloorShare.vue?vue&type=script&lang=js"
import style0 from "./addFloorShare.vue?vue&type=style&index=0&id=6aa63873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa63873",
  null
  
)

export default component.exports